import {
    LOAD_CONTRACTOR_QUOTA,
    EXPORT_CONTRACTOR_QUOTA,
    CONTRACTOR_QUOTA_ORIGIN_LOCATION,
    CONTRACTOR_QUOTA_MATERIAL,
    LOAD_CONTRACTOR,
    CREATE_CONTRACTOR_QUOTA,
    UPDATE_CONTRACTOR_QUOTA,
    CONTRACTOR_QUOTA_PREVIEW,
    CONTRACTOR_QUOTA_MATERIAL_EDIT,
    REMOVE_LISTS,
} from './actions'

const initialState = {
    // *load ข้อมูล detail
    update_list: [],
    check_update: false,
    
    // *load ข้อมูลต้นแหล่ง
    source_list: [],
    check_source_list: false,

    // *load ข้อมูลวัตถุดิบ
    material_list: [],
    check_material_list: false,

    material_list_edit: [],
    check_material_list_edit: false,

    // *load ข้อมูลผู้รับเหมา
    contractor_list: [],
    check_contractor_list: false,

    // *preview ข้อมูลโควตา
    preview_list: [],
    check_preview_list: false,

    lists: [],
    total: 1,
    loading: false,
    draw: -1,
    check: true,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case REMOVE_LISTS:
            return initialState

        case LOAD_CONTRACTOR_QUOTA.REQUEST:
            const { loading } = action.payload.data
            return {
                ...state,
                loading: loading,
            }
        case LOAD_CONTRACTOR_QUOTA.SUCCESS:
            const { page } = action.payload
            for (let i = 0; i < action.payload.lists.data.length; i++) {
                action.payload.lists.data[i].rowNumber = i + 1
                if (page > 1)
                action.payload.lists.data[i].rowNumber =
                    action.payload.lists.data[i].rowNumber + (page - 1) * 10
            }
            return {
                ...state,
                lists: action.payload.lists.data,
                total:
                action.payload.lists.total - 1 <= 0
                    ? 1
                    : action.payload.lists.total <= 0
                    ? 1
                    : action.payload.lists.total,
                loading: false,
                draw: Math.floor(Math.random() * 999 + 1),
            }

        case EXPORT_CONTRACTOR_QUOTA.REQUEST:
            return {
                ...state,
                loading: true,
            }
        case EXPORT_CONTRACTOR_QUOTA.SUCCESS:
            return {
                ...state,
                loading: false,
            }

        case CONTRACTOR_QUOTA_ORIGIN_LOCATION.REQUEST:
            return {
                ...state,
                source_list: [],
                check_source_list: true,
            }
        case CONTRACTOR_QUOTA_ORIGIN_LOCATION.SUCCESS:
            return {
                ...state,
                source_list: action.payload.lists || [],
                check_source_list: false,
            }

        case CONTRACTOR_QUOTA_MATERIAL.REQUEST:
            return {
                ...state,
                material_list: [],
                check_material_list: true,
            }  
        case CONTRACTOR_QUOTA_MATERIAL.SUCCESS:
            return {
                ...state,
                material_list: action.payload.lists || [],
                check_material_list: false,
            }

        case LOAD_CONTRACTOR.REQUEST:
            return {
                ...state,
                contractor_list: [],
                check_contractor_list: true,
            }  
        case LOAD_CONTRACTOR.SUCCESS:
            return {
                ...state,
                contractor_list: action.payload.lists || [],
                check_contractor_list: false,
            }

        case CREATE_CONTRACTOR_QUOTA.REQUEST:
            return {
                ...state,
                check_update: true,
            } 
        case CREATE_CONTRACTOR_QUOTA.SUCCESS:
            return {
                ...state,
                check_update: false,
            } 
            
        case UPDATE_CONTRACTOR_QUOTA.REQUEST:
            return {
                ...state,
                update_list: [],
                check_update: true,
            } 
        case UPDATE_CONTRACTOR_QUOTA.SUCCESS:
            return {
                ...state,
                update_list: action.payload.lists || [],
                check_update: false,
            }  

        case CONTRACTOR_QUOTA_PREVIEW.REQUEST:
            return {
                ...state,
                preview_list: [],
                check_preview_list: true,
            }

        case CONTRACTOR_QUOTA_PREVIEW.SUCCESS:
            return {
                ...state,
                preview_list: action.payload.lists || [],
                check_preview_list: false,
            }

        case CONTRACTOR_QUOTA_MATERIAL_EDIT.REQUEST:
            return {
                ...state,
                material_list_edit: [],
                check_material_list_edit: true,
            }

        case CONTRACTOR_QUOTA_MATERIAL_EDIT.SUCCESS:
            return {
                ...state,
                material_list_edit: action.payload.lists || [],
                check_material_list_edit: false,
            }

            
          
        default:
            return state
    }
}